import {Hash} from "../../../interfaces/hashInterfaces";
import {IRoleData, IRoleMetadata} from "../../../interfaces/roleInterfaces";

export enum GroupRoleCapability {
  manageMembers = 1,
  manageRoles = 2,
  assignGroupMembersToWorkflowSteps = 3,
  deleteGroup = 4
}

export const GroupRoleMetadata: Hash<IRoleMetadata> = {
  [GroupRoleCapability.manageMembers]: {
    label: 'Manage members',
  },
  [GroupRoleCapability.manageRoles]: {
    label: 'Manage roles',
  },
  [GroupRoleCapability.assignGroupMembersToWorkflowSteps]: {
    label: 'Assign group members to workflow steps',
  },
  [GroupRoleCapability.deleteGroup]: {
    label: 'Delete group',
  },
};

export const GroupRoleData: Hash<Hash<IRoleData<GroupRoleCapability>[]>> = {
  'General Settings': {
    'Manage Groups': [
      {
        label: GroupRoleMetadata[GroupRoleCapability.manageMembers].label,
        capability: GroupRoleCapability.manageMembers
      },
      {
        label: GroupRoleMetadata[GroupRoleCapability.manageRoles].label,
        capability: GroupRoleCapability.manageRoles
      },
      {
        label: GroupRoleMetadata[GroupRoleCapability.assignGroupMembersToWorkflowSteps].label,
        capability: GroupRoleCapability.assignGroupMembersToWorkflowSteps
      },
      {
        label: GroupRoleMetadata[GroupRoleCapability.deleteGroup].label,
        capability: GroupRoleCapability.deleteGroup
      },
    ],
  }
};

export let groupViewOrganizationManagementCapabilities = [
  GroupRoleCapability.manageMembers,
  GroupRoleCapability.manageRoles,
  GroupRoleCapability.deleteGroup
];
